import React from 'react'

import { Box } from '@mui/material'
import { AppButtonIcon } from '@components'
import { useAdminMappingUpdate } from 'Pages/Admin/AdminMapping/Table/@hooks'
import { LoadingIconSeeker } from '@ui-seeker/core'


export default function actionsColumn(path) {

	return {
		name: 'idCustom',
		label: 'Actions',
		options: {
			filter: false,
			setCellProps: () => ({ sx: { width: 50 } }),
			customBodyRowRenderLite: value => <RenderActionsColumn value={value} path={path}/>,
		}
	}
}

function RenderActionsColumn({ value, path }) {
	const { handleDeleteMapping, isLoadingDelete } = useAdminMappingUpdate()

	return <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
		{isLoadingDelete && <LoadingIconSeeker size={20}/>}
		{!isLoadingDelete && <AppButtonIcon
			iconWeight="solid"
			sx={{ color: "error.main" }}
			icon="trash"
			tooltip="Delete Mapping"
			onClick={() => handleDeleteMapping(value, path)}
		/>}
	</Box>
}